export enum MessageInternalNoteKind {
  Note = "note",
  AiHandoff = "ai_handoff",
  AiNoReply = "ai_no_reply",
  ActionAuthorization = "action_authorization",
  ChannelConversion = "channel_conversion",
  AuthorizeShopApp = "authorize_shop_app",
}
